import React, { useEffect, useMemo, useState } from 'react';
import useAuthenticatedUserService, { UserName } from 'infrastructure/security/authentication/authenticatedUserService';
import InstantFeedbackButton from 'domain/people/feedback/instantFeedback/InstantFeedbackButton';
import { Box } from '@mui/material';
import CopyTokenButton from 'infrastructure/security/authentication/CopyTokenButton';
import SupportRequestModalDecorator from 'domain/gpo/oneStop/feedbackModal/SupportRequestModalDecorator';
import HeaderSearchCandidateSelect from 'domain/recruiting/candidate/shared/input/headerSearch/HeaderSearchCandidateSelect';
import { useLocation } from 'react-router-dom';
import { VACANCY_GROUP_PATH } from 'domain/recruiting/newVacancy/routing';
import { IconButton, Menu, MenuItem, useMediaQuery } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTheme } from '@mui/material/styles';
import NotificationsHeader from './notification/NotificationsHeader';
import { HeaderMenuItems } from 'framework/ui/menu';
import CurrentUserActions from './CurrentUserActions';
import { CANDIDATES_PATH } from 'domain/shared/candidate';

const DefaultHeader = () => {
  const location = useLocation();
  const [userName, setUserName] = useState<Nullable<UserName>>(null);
  const { getUserName } = useAuthenticatedUserService();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const isShowCandidateSearch = useMemo(
    () => location.pathname.includes(CANDIDATES_PATH) || location.pathname.includes(VACANCY_GROUP_PATH),
    [location.pathname],
  );

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    (async () => {
      const name = await getUserName();
      setUserName(name);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (userName === null) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <Box sx={{ width: { md: `calc(100% - 550px)` }, minWidth: 0, marginRight: 'auto' }}>
        <HeaderMenuItems />
      </Box>

      {isMobile ? (
        // Mobile layout
        <Box sx={{ display: 'flex' }}>
          <MenuItem>
            <NotificationsHeader />
          </MenuItem>

          <IconButton onClick={handleMenuOpen}>
            <MoreVertIcon />
          </IconButton>

          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
            {isShowCandidateSearch && (
              <MenuItem>
                <HeaderSearchCandidateSelect />
              </MenuItem>
            )}

            <MenuItem sx={{ '& > button': { width: '100%' } }}>
              <InstantFeedbackButton />
            </MenuItem>

            <MenuItem sx={{ '& > button': { width: '100%' } }}>
              <SupportRequestModalDecorator />
            </MenuItem>
            <MenuItem sx={{ '& > button': { width: '100%' } }}>
              <CopyTokenButton />
            </MenuItem>
          </Menu>

          <CurrentUserActions userName={userName} />
        </Box>
      ) : (
        // Desktop layout
        <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
          {isShowCandidateSearch && <HeaderSearchCandidateSelect />}
          <NotificationsHeader />
          <InstantFeedbackButton />

          <SupportRequestModalDecorator />

          <CopyTokenButton />
          <CurrentUserActions userName={userName} />
        </Box>
      )}
    </Box>
  );
};

export default DefaultHeader;
